<div class="content-detail-container notranslate">
  <div [ngClass]="[
      isShoppingCard
        ? 'description-content description-content-width with-shopping-card'
        : 'description-content description-content-width',
      fullwidth ? 'fullwidth' : ''
    ]">
    <ng-container *ngIf="!isFromInvoiceDetail">
      <div class="section-description">
        <div class="title-description  font-omicron-medium padding-title text-right text-size-2 p-0">
          <b>Resumen de productos</b>
        </div>
      </div>
      <div class="section-description">
        <div class="title-description  font-omicron-medium padding-title text-right text-size-2 p-0">
          Total de productos:
        </div>
        <div class="title-description-total text-size-1 p-0">
          {{ totalDescription.productTotal | displayDefaultZero }}
        </div>
      </div>
      <div class="section-description">
        <div class="title-description  font-omicron-medium padding-title text-right text-size-2 p-0">
          Total de piezas:
        </div>
        <div class="title-description-total text-size-1 p-0">
          {{ totalDescription.piecesTotal | displayDefaultZero }}
        </div>
      </div>
      <div class="separator"></div>
    </ng-container>
    <div class="section-description">
      <div class="title-description  font-omicron-medium padding-title text-right text-size-2 p-0">
        Subtotal:
      </div>
      <div id="subtotal-discount" *ngIf="disableCostDiscount === false" class="title-description-total text-size-1 p-0">
        ${{ totalDescription.subtotal - totalDescription.totaldiscount | numberNotRound }}
      </div>

      <div id="subtotal" *ngIf="disableCostDiscount" class="title-description-total text-size-1 p-0">
        ${{ totalDescription.subtotal | numberNotRound }}
      </div>
    </div>
    <div class="section-description" *ngIf="disableCostShipping">
      <div class="title-description  font-omicron-medium padding-title text-right text-size-2 p-0">
        Costo de envío:
      </div>
      <div id="costShipping" class="title-description-total text-size-1 p-0"
        *ngIf="totalDescription.costShipping !== 0 && !shippingCostDiscount">
        ${{ totalDescription.costShipping | numberNotRound }}
      </div>
      <div id="costShipping" class="title-description-total text-size-1 p-0" *ngIf="shippingCostDiscount">
        <p class="m-0" *ngIf="totalDescription.costShipping !== 0">
          <span class="discount-total">${{ totalDescription.costShipping | numberNotRound }}</span>&nbsp;
          <span class="special-discount-color">${{ shippingCostDiscountAmount | numberNotRound }}</span>
        </p>
        <p class="m-0" *ngIf="totalDescription.costShipping === 0">
          ${{ totalDescription.costShipping | numberNotRound }}
        </p>
      </div>
      <div id="costShipping" class="title-description-total text-size-1 p-0"
        *ngIf="totalDescription.costShipping === 0 && !shippingCostDiscount">
        Gratis
      </div>
    </div>
    <div class="section-description special-discount-color" *ngIf="totalDescription.promotionalCodeAmount > 0">
      <div class="title-description  font-omicron-medium padding-title text-right text-size-2 p-0">
        Código promocional:
      </div>
      <div class="title-description-total text-size-1 p-0">
        ${{ totalDescription.promotionalCodeAmount | numberNotRound }}
      </div>
    </div>
    <div class="section-description special-discount-color" *ngIf="therePromotionalCode">
      <div class="p-0 d-flex justify-content-center align-items-center promo-label">
        <img class="mr-2" src="assets/icons/label-promotional-code.svg" alt="label" />
        {{ promotionalCode }}
      </div>
    </div>
    <div class="section-description special-discount-color"
      *ngIf="disableCostDiscount && totalDescription.promotionalCodeAmount <= 0">
      <div class="title-description  font-omicron-medium padding-title text-right text-size-2 p-0">
        Descuento:
      </div>
      <div id="discount" class="title-description-total text-size-1 p-0">
        ${{ totalDescription.totaldiscount | numberNotRound }}
      </div>
    </div>
    <div class="section-description special-discount-color"
      *ngIf="totalDescription.hasDiscountSpecial && totalDescription.promotionalCodeAmount <= 0">
      <div class="title-description  font-omicron-medium padding-title text-right text-size-2 p-0">
        Descuento especial:
      </div>
      <div id="special-discount" class="title-description-total text-size-1 p-0">
        ${{ totalDescription.discountSpecial | numberNotRound }}
      </div>
    </div>
    <div class="section-description">
      <div class="title-description  font-omicron-medium padding-title text-right text-size-2 p-0">
        IVA:
      </div>
      <div id="tax" class="title-description-total text-size-1 p-0">
        ${{ totalDescription.tax | numberNotRound }}
      </div>
    </div>
    <div class="separator"></div>
    <div class="section-description" *ngIf="!totalDescription.hasDiscountSpecial">
      <div class="title-description padding-title text-right p-0"
        [ngClass]="totalDescription.hasFavorBalance ? 'text-size-2':'text-size-3 font-omicron-bold '">
        Total:
      </div>
      <div id="total" class="title-description-total p-0"
        [ngClass]="totalDescription.hasFavorBalance ? 'text-size-2':'text-size-3 font-omicron-bold '">
        ${{ totalDescription.total | numberNotRound }}
      </div>
    </div>
    <div class="section-description" *ngIf="totalDescription.hasDiscountSpecial">
      <div class="title-description padding-title text-right p-0"
        [ngClass]="totalDescription.hasFavorBalance ? 'text-size-2':'text-size-3 font-omicron-bold '">
        Total:
      </div>
      <div id="total-special-discount" class="title-description-total p-0"
        [ngClass]="totalDescription.hasFavorBalance ? 'text-size-2':'text-size-3 font-omicron-bold '">
        ${{ totalDescription.totalWithSpecialDiscount | numberNotRound }}
      </div>
    </div>
    <div class="section-description special-discount-color " *ngIf="totalDescription.hasFavorBalance">
      <div class="title-description padding-title text-right text-size-2 p-0">
        Saldo a favor:
      </div>
      <div id="total-special-discount" class="title-description-total text-size-2 p-0">
        ${{ totalDescription.favorBalance | numberNotRound }}
      </div>
    </div>
    <div class="section-description" *ngIf="totalDescription.hasFavorBalance">
      <div class="title-description padding-title text-right text-size-3 font-omicron-bold p-0">
        Gran total:
      </div>
      <div id="total-special-discount" class="title-description-total text-size-3 font-omicron-bold p-0">
        ${{ (totalDescription.hasDiscountSpecial ?
        (totalDescription.totalWithSpecialDiscount - totalDescription.favorBalance) :
        (totalDescription.total - totalDescription.favorBalance)) | numberNotRound
        }}
      </div>
    </div>
  </div>
  <div class="mt-3 col-12 d-flex justify-content-between" *ngIf="showFavorBalance">
    <div class="d-flex p-0 m-0 col-6 align-items-center justify-content-center">
      <img src="./assets/icons/favor-balance.svg" alt="image">
      <p class="mb-0 text-size-2 pl-1">Tiene <span class="text-size-1">${{ favorBalanceTotal | numberNotRound }}
          MXN</span> a favor
      </p>
    </div>

    <div class="d-flex p-0 m-0 col-6 align-items-center  justify-content-center">
      <mat-checkbox class="mr-1 favor-balance-check" [checked]="favorBalanceStatus"
        (click)="favorBalanceChange($event)"></mat-checkbox>
      <p class="mb-0 text-size-1 pt-1">Deseo usarlos</p>
    </div>
  </div>
  <div class="mx-4">
    <ng-content select="[paymentMethods]"></ng-content>
  </div>

  <div class="buttons-actions" *ngIf="
      totalDescription.fromCalled !== callPlaceCompare.confirmOrder &&
      totalDescription.fromCalled != callPlaceCompare.successPay &&
      showButtons
      ">
    <button mat-stroked-button class="with-buttons font-size-button d-flex flex-nowrap white-button" autofocus="false"
      color="primary" *ngIf="!totalDescription.isFromDetailOrders && !isShoppingCard" (click)="clickOnCanceledButton()">
      Cancelar
    </button>
    <button name="btn-continue" mat-raised-button class="with-buttons font-size-button blue-button margin-button"
      color="primary" *ngIf="
        !totalDescription.isFromDetailOrders &&
        totalDescription.fromCalled != callPlaceCompare.successPay
        " (click)="clickOnContinueButton()" [disabled]="disable">
      Continuar
    </button>
    <button mat-raised-button class="with-buttons font-size-button blue-button" color="primary" *ngIf="
    totalDescription.isFromDetailOrders && 
    (totalDescription.fromCalled === callPlaceCompare.metricsPromotion ||
    totalDescription.fromCalled === callPlaceCompare.activeOrders ||
    totalDescription.fromCalled === callPlaceCompare.detailOrderList)" (click)="printPdf()">
      Imprimir
    </button>
    <button mat-raised-button class="with-buttons font-size-button blue-button margin" color="primary" *ngIf="
        totalDescription.isFromDetailOrders &&
        totalDescription.fromCalled != callPlaceCompare.activeOrders &&
        totalDescription.fromCalled != callPlaceCompare.metricsPromotion &&
        totalDescription.fromCalled !== callPlaceCompare.pendingOrders &&
        !isAdvisorRole" (click)="editAndShopping()">
      Editar y volver a comprar
    </button>
    <button mat-raised-button class="with-buttons font-size-button blue-button margin-button" color="primary"
      *ngIf="showEditOrderButton" (click)="editOrder()">
      Editar
    </button>
  </div>
  <div *ngIf="showImage" class="d-flex justify-content-center pt-2">
    <div>
      <div class="font-omicron-bold text-size-1">
        Método de pago
      </div>
      <div class="d-flex align-items-center">
        <app-payment-methods-image class="width-100" [srcImage]="paymentImage"
          [paymentTypeCredit]="paymentInformation.typeOfMethod || ''">
        </app-payment-methods-image>
        <div class="text text-size-1 font-omicron-bold"
          *ngIf="paymentInformation.cardNumber && paymentInformation.typeOfMethod !== paymentTypeCompare.credit">
          <p class="color-blue-omicron font-omicron-bold mb-0">{{ paymentInformation.holderName }}</p>
          <p class="color-black font-omicron-bold mb-0">{{ paymentInformation.cardNumber | hideCard:
            paymentInformation.brand }}</p>
        </div>
      </div>
      <div class="text-size-1 font-omicron-medium pt-2" *ngIf="paymentInformation.monthlyInstallments">
        <span class="color-black">Plan de pago: </span>
        <span class="color-blue-omicron font-omicron-bold">{{ paymentInformation.monthlyInstallments }} meses sin intereses</span>
      </div>
    </div>
  </div>
  <div class="logo-conekta pt-2"
    *ngIf="paymentTypeCredit !== paymentTypeInfo.credit && paymentTypeCredit !== paymentTypeInfo.bbvaMulti && paymentTypeCredit !== paymentTypeInfo.oxxo && showImage">
    <img class="conekta-logo" src="./assets/icons/conekta.png" alt="conektaIcon" />
  </div>
  <div *ngIf="disableUtilities && callPlace !== callPlaceCompare.detailOrderList"
    class="utilities-content animate__animated animate__pulse">
    <div class="font-omicron-medium color-omicron title1 text-size-3">
      Creciendo con tu negocio
    </div>
    <div class="font-omicron-medium color-omicron title2 text-size-3">
      "¡Felicidades!, este pedido le puede representar una utilidad de
      <strong class="strong-text font-omicron-bold text-size-3">${{ totalDescription.totalUtilities | numberNotRound
        }}</strong>
      pesos"
    </div>

    <div class="font-omicron-medium color-omicron text-size-low text-center italic-text" *ngIf="
        totalDescription.cartContentType ===
          cartContentTypeCompare.packagesAndProducts || showAsteriskPackages
      ">
      <p class="mb-0">
        <span class="packages-not-included-color">*</span>No incluye paquetes
      </p>
    </div>
  </div>
  <div class="content-detail-legend-by-authorize-order" *ngIf="
      totalDescription.fromCalled === callPlaceCompare.pendingOrders &&
      totalDescription.isAuthorizeOrderButton &&
      rol === roles.doctor
    " class="utilities-content">
    <div class="detail-legend-by-authorize-order color-black font-omicron-bold text-size-1">
      {{ legendByAuthorizeOrder.legendOkDeliveryAndTaxData }}
    </div>
    <div class="detail-legend-by-authorize-order color-black font-omicron-bold text-size-1">
      {{ legendByAuthorizeOrder.legendOkRecipe }}
    </div>
  </div>
</div>